import { PositionListing } from './positionListing';

export class OpportunityBoard {
  public id: string;
  public workspaceId: string;
  public title: string;
  public description: string;
  public isActive: boolean;
  public slug: string;
  public positionListings: PositionListing[];
  public quickFilterNames: string[];

  constructor() {}

  public static parse(data: any): OpportunityBoard {
    if (!data) return null;

    let board = new OpportunityBoard();
    Object.assign(board, data);

    return board;
  }
}
